import { render, staticRenderFns } from "./multi.vue?vue&type=template&id=10eff46e&scoped=true&"
import script from "./multi.vue?vue&type=script&lang=js&"
export * from "./multi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eff46e",
  null
  
)

export default component.exports